import React, { memo, useState } from 'react';
import { UpdateGmbLocationParams } from '../../../../requests/partner/gmb-locations';
import { ServiceArea } from '../../../../models/gmb-location';

import BaseRaw from './BaseRaw';
import ServiceAreaModal from '../form-modal/ServiceAreaModal';

type Props = {
  label: string;
  serviceArea: ServiceArea | null;
  handleUpdate?: (params: UpdateGmbLocationParams) => Promise<void>;
  editable?: boolean;
};

const ServiceAreaRaw: React.FC<Props> = (props) => {
  const editable = props.editable === undefined || props.editable ? true : false;
  const [isShow, setIsShow] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleModal = () => {
    setIsShow(!isShow);
  };
  const values = props.serviceArea?.places?.placeInfos
    ?.map((v) => v.placeName || v.name)
    .join('\n');
  const handleSubmit = async (params: UpdateGmbLocationParams): Promise<void> => {
    setIsLoading(true);
    try {
      if (props.handleUpdate !== undefined) await props.handleUpdate(params);
      setIsShow(!isShow);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <BaseRaw
        isLoading={isLoading}
        label={props.label}
        value={values || '未設定'}
        handleModal={editable ? handleModal : undefined}
      />
      {editable ? (
        <ServiceAreaModal
          isShow={isShow}
          label={props.label}
          serviceArea={props.serviceArea}
          handleModal={handleModal}
          handleUpdate={handleSubmit}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(ServiceAreaRaw);
